import React, { FC, ReactElement, ReactNode } from 'react'
import { Button } from '@material-ui/core'
import { isStringNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'
import { redirectToURL } from '../../../../NonReact/utils/LocationUtils'
import { URLConstructor } from '../../../../NonReact/utils/URLBuilder'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'

type ButtonProps = {
    children: ReactNode
    className?: string
    onClick?: () => void
    disabled?: boolean
    type?: 'button' | 'submit' | 'reset'
    href?: undefined
    isOutlined?: boolean
    showErrorBadge?: boolean
}

type AnchorProps = {
    children: ReactNode
    className?: string
    href: string
    onClick?: undefined
    disabled?: boolean
    type?: undefined
    isOutlined?: boolean
    showErrorBadge?: boolean
}

export type RoundedButtonProps = ButtonProps | AnchorProps

export const RoundedButton: FC<RoundedButtonProps> = ({
    children,
    className,
    onClick,
    disabled,
    type,
    href,
    isOutlined,
    showErrorBadge
}: RoundedButtonProps): ReactElement => (
    <Button
        onClick={
            isStringNotEmpty(href) ? (): void => redirectToURL(URLConstructor.newInstance({ baseURL: href })) : onClick
        }
        className={`rounded-button ${isOutlined ? 'rb-outlined' : EMPTY_STRING} ${
            showErrorBadge ? 'rb-error-badge' : EMPTY_STRING
        } ${className}`}
        disabled={disabled}
        type={type}
    >
        {children}
    </Button>
)
